import DealCard from '../components/DealCard';

export default function FavouritesPage({ favourites, deals, shoppingList, onAddToList, onToggleFavourite }) {
  const listSet = new Set((shoppingList || []).map(i => i.name + i.store));
  const favSet  = new Set((favourites  || []).map(f => f.name + f.store));

  // Which favourited items are currently in the deals list
  const onSaleNow = (deals || []).filter(d => favSet.has(d.name + d.store));
  const onSaleSet = new Set(onSaleNow.map(d => d.name + d.store));

  // Which favourites are NOT currently on sale
  const watching = (favourites || []).filter(f => !onSaleSet.has(f.name + f.store));

  if (!favourites?.length) {
    return (
      <div className="fav-empty">
        <p className="fav-empty-icon">♡</p>
        <p className="fav-empty-title">No favourites yet</p>
        <p className="fav-empty-hint">
          Click the <strong>♡</strong> on any deal to save it —
          we'll highlight it here whenever it goes on sale again.
        </p>
      </div>
    );
  }

  return (
    <div className="fav-page">
      {onSaleNow.length > 0 && (
        <section className="fav-section">
          <div className="fav-section-header">
            <h2 className="fav-section-title">On sale now</h2>
            <span className="fav-badge fav-badge--sale">{onSaleNow.length} deal{onSaleNow.length !== 1 ? 's' : ''}</span>
          </div>
          <div className="deal-grid">
            {onSaleNow.map((deal, i) => (
              <DealCard
                key={i}
                deal={deal}
                onAddToList={onAddToList}
                inList={listSet.has(deal.name + deal.store)}
                isFavourited={true}
                onToggleFavourite={onToggleFavourite}
              />
            ))}
          </div>
        </section>
      )}

      {watching.length > 0 && (
        <section className="fav-section">
          <div className="fav-section-header">
            <h2 className="fav-section-title">Watching</h2>
            <span className="fav-badge fav-badge--watch">{watching.length} saved</span>
          </div>
          <p className="fav-watch-hint">We'll move these up when they go on sale.</p>
          <ul className="fav-watch-list">
            {watching.map((fav, i) => (
              <li key={i} className="fav-watch-item">
                <div className="fav-watch-info">
                  <span className="shopping-item-store-badge" data-store={fav.store}>{fav.store}</span>
                  <span className="fav-watch-name">{fav.name}</span>
                </div>
                <button
                  className="fav-remove-btn"
                  onClick={() => onToggleFavourite({ name: fav.name, store: fav.store })}
                  title="Remove from favourites"
                >
                  ✕
                </button>
              </li>
            ))}
          </ul>
        </section>
      )}
    </div>
  );
}
